import { render, staticRenderFns } from "./MpRotateV2.vue?vue&type=template&id=4c2649fc&scoped=true&"
import script from "./MpRotateV2.vue?vue&type=script&lang=js&"
export * from "./MpRotateV2.vue?vue&type=script&lang=js&"
import style1 from "./MpRotateV2.vue?vue&type=style&index=1&id=4c2649fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2649fc",
  null
  
)

export default component.exports